<template>
  <App class="uav-project-view">
    <AppBar>
      <div class="flex-wrap">
        <BaseIcon icon="Building-" size="25" color="var(--primary)" style="margin-right:10px" />
        <a style="color:var(--primary);margin-right:5px;" @click="RouteTo('/core/uav-project')">全景720场景设计</a>
        /
        <a
          v-if="project && project.id"
          style="color:var(--primary);margin:0 5px;"
          @click="RouteTo(`/core/uav-projects/${project.id}/editor`, true)"
        >{{ project.name }}</a>
        <span v-else style="margin:0 5px;">项目预览</span>
        / 预览
      </div>
      <div class="flex-wrap">
        <ButtonGroup size="small">
          <Button @click="RouteTo(`/core/uav-projects/${projectId}/editor`, true)">返回设计</Button>
          <Button @click="RouteTo('/core/uav-project')">项目列表</Button>
        </ButtonGroup>
      </div>
      <div class="flex-wrap split5"></div>
    </AppBar>

    <AppMask v-if="!is_ready" />

    <AppClient :collapse-left="true" :collapse-right="true" class="uav-view-client">
      <div class="uav-view-body">
        <UAVViewer
          :project-id="projectId"
          :use-public-api="usePublicApi"
          :fullscreen="false"
          controls-position="side-left"
          :show-subtitle="true"
          :show-photo-btn="true"
          :enable-annotation="true"
          :show-sandbox="true"
          :use-icons="true"
          :float-header="true"
        />
      </div>
    </AppClient>
  </App>
</template>

<script>
import { mapGetters } from 'vuex';
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppMask from '@/components/app/mask';
import AppClient from '@/components/app/client';
import UAVViewer from '@/components/uav/viewer.vue';

export default {
  name: 'UAVProjectView',
  routerOption: {
    as_object: true,
  },
  metaInfo: {
    title: '全景照片',
  },
  components: {
    App,
    AppBar,
    AppMask,
    AppClient,
    UAVViewer,
  },
  computed: {
    ...mapGetters('uav-project', ['is_ready', 'project']),
    projectId() {
      return this.$route.params.id;
    },
    usePublicApi() {
      try {
        const session = this.$store.getters['session/session'];
        return !(session && session.id);
      } catch (error) {
        return true;
      }
    },
  },
  watch: {
    $route: {
      handler() {
        this.loadProject();
      },
      immediate: true,
    },
  },
  methods: {
    loadProject() {
      if (!this.projectId) return;
      this.$api.afterLogin(() => {
        this.$store.dispatch('uav-project/loadProject', this.projectId);
      });
    },
  },
};
</script>

<style scoped lang="less">
.uav-project-view {
  height: 100%;
}

.uav-view-client {
  background: var(--bg1);
  height: 100%;
  overflow: hidden;
}

.uav-view-body {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
</style>
